export default __webpack_public_path__ + "static/media/8_2.bd856c47.jpg";